import React from "react";
//#region types
import { EditableFormInnerProps, GenericFormSection } from "models/propTypes/genericFormProps";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import TabEvents from "../tabs/tabEvents";
import useCheckVisibility from "./hooks/useCheckVisibility";
import useCheckHasErrors from "./hooks/useCheckHasErrors";
import TabTop from "../tabs/tabTop";
import TabPanel from "../tabs/tabPanel";
import GenericFormInner from "./genericFormInner";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import LocalizationHelperInstance from "utils/helpers/localizationHelper";

function EditableFormInnerTab<T extends Record<string, any>>(props: EditableFormInnerProps<T>) {
  const { getFieldHidden } = useCheckVisibility<T>();
  const { getHasErrors } = useCheckHasErrors<T>(true);

  const fields = (props.fields as GenericFormSection<T>[])?.filter((field) => !getFieldHidden(field.hidden));

  return (
    <Grid container item direction="column" xs className={cssExports.tabsFormContainer}>
      <TabEvents
        render={(currentIndex, onTabChange, resetTabIndex) => (
          <>
            <TabTop
              tabKey={"dialog-tab"}
              value={currentIndex}
              onChange={onTabChange}
              visibleScrollbar
              tabs={fields.map((item, index) => {
                return {
                  text: (
                    <>
                      {item.label && (
                        <Grid
                          container
                          direction="row"
                          className={
                            index !== currentIndex && getHasErrors(item, undefined) ? cssExports.tabErrorIndicator : ""
                          }
                          alignItems="center"
                        >
                          {LocalizationHelperInstance.getFormattedMessage(item.label, item.label)}

                          {index !== currentIndex && getHasErrors(item, undefined) && (
                            <Icon icon={IconDefinitionConstants.WExclamation} />
                          )}
                        </Grid>
                      )}
                    </>
                  ),
                };
              })}
            />
            <React.Fragment>
              {fields.map((tab, index) => {
                return (
                  <TabPanel key={index} value={currentIndex} index={index}>
                    <Grid container>
                      <GenericFormInner<T>
                        {...props}
                        key={`genericFormInner-${index}`}
                        fields={tab.innerFields}
                        inline={tab.inline ?? props.inline}
                        enableControlLables={tab.enableControlLables ?? props.enableControlLables}
                        formGridLayout={tab.formGridLayout ?? props.formGridLayout}
                      />
                    </Grid>
                  </TabPanel>
                );
              })}
            </React.Fragment>
          </>
        )}
      />
    </Grid>
  );
}

export default EditableFormInnerTab;
